import React, { useState, useEffect } from 'react';
import AccordionNew from '../../../../components/accordionNew';
import { fetchExportJobBookingDetails, fetchExportJobCblDetails, fetchExportJobClrDetails, fetchExportJobCustomerInvoice, fetchExportJobEtsDetails } from 'actions/exportJob'
import { connect } from 'react-redux';
import PropertyDisplay from 'components/cost-revenue/PropertyDisplay';
import Table from 'components/data-table/Table';
import { IPaternList, IPattern } from '../../utils/models';
import { clearFormat, formatData, formatValueIfNullOrUndefined, sortElementByKey, simplifyNull } from 'utilities/util';
import { IStore } from 'reducers/index';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { bookingsCols, cblCols, clrCols, customerInvoiceExportJobCols, equipmentTransportShipmentsCols } from 'constants/tableConstants'
import { IExportDetailsBooking, IExportDetailsBookingAndCargo, IExportDetailsCbl, IExportDetailsClr, IExportDetailsCustomerInvoice, IExportDetailsEts, IExportJobDetail } from 'reducers/exportJob/models';
import { redirectToViewInvoice } from 'utilities/route-utils';

export interface IExportJobProps extends IMapStateToProps, IDispatch {
    link: (url: string) => void;
    organisation: IPaternList[],
    locations: IPaternList[],
    jobIdDetails: IPaternList[],
    equipments: IPattern,
    voyages: IPattern,
    exportJobDetails: IExportJobDetail,
    isExtraDocumentFeatureEnabled: boolean,
    exportJobId: number,
}

interface IMapStateToProps {
    exportDetailsBooking: IExportDetailsBookingAndCargo;
    exportDetailsClr: IExportDetailsClr[];
    exportDetailsCbl: IExportDetailsCbl[];
    exportDetailsEts: IExportDetailsEts[];
    exportDetailsCustomerInvoice: IExportDetailsCustomerInvoice[];
}

interface IDispatch {
    fetchExportJobBookingDetails: (exportJobId: number) => Promise<void>;
    fetchExportJobClrDetails: (exportJobId: number) => Promise<void>;
    fetchExportJobCblDetails: (exportJobId: number) => Promise<void>;
    fetchExportJobEtsDetails: (exportJobId: number) => Promise<void>;
    fetchExportJobInvoice: (exportJobId: number) => Promise<void>;
}
interface InitialState<T> {
    data: T,
    cols: any,
    name: string
}


const ExportJobDetails = (props: IExportJobProps) => {
    const { exportJobDetails, organisation,
        locations, jobIdDetails, equipments, isExtraDocumentFeatureEnabled,
        voyages, exportDetailsBooking, exportDetailsClr, exportDetailsCbl, exportDetailsEts, exportDetailsCustomerInvoice, exportJobId } = props;

    const cargoInitialState: IPaternList[] = [];
    const bookingInitialState: InitialState<IExportDetailsBooking[]> = {
        data: [],
        cols: bookingsCols,
        name: 'export-job-bookings-'
    }
    const clrInitialState: InitialState<IExportDetailsClr[]> = {
        data: [],
        cols: clrCols,
        name: 'export-job-clr-'
    }
    const cblInitialState: InitialState<IExportDetailsCbl[]> = {
        data: [],
        cols: cblCols,
        name: 'export-job-cbl-'
    }
    const etsInitialState: InitialState<IExportDetailsEts[]> = {
        data: [],
        cols: equipmentTransportShipmentsCols,
        name: 'export-job-ets-'
    }

    const extraEtsInitialState: InitialState<IExportDetailsEts[]> = {
        data: [],
        cols: equipmentTransportShipmentsCols,
        name: 'export-job-extra-ets-'
    }

    const customerInvoiceInitialState: InitialState<IExportDetailsCustomerInvoice[]> = {
        data: [],
        cols: customerInvoiceExportJobCols,
        name: 'export-job-invoice-'
    }

    const [exportJobDetailsOrganizationState, setExportJobDetailsOrganizationState] = useState(organisation);

    const [exportJobDetailsCargoState, setExportJobDetailsCargoState] = useState(cargoInitialState);

    const [exportJobDetailsBooking, setExportJobDetailsBooking] = useState(bookingInitialState);

    const [exportJobDetailsClrState, setExportJobDetailsClrState] = useState(clrInitialState);

    const [exportJobDetailsCblState, setExportJobDetailsCblState] = useState(cblInitialState);

    const [exportJobDetailsEtsState, setExportJobDetailsEtsState] = useState(etsInitialState);

    const [exportJobDetailsExtraEtsState, setExportJobDetailsExtraEtsState] = useState(extraEtsInitialState);

    const [exportJobDetailsCustomerInvoiceState, setExportJobDetailsCustomerInvoiceState] = useState(customerInvoiceInitialState);

    useEffect(() => {
        let parsedBooking = exportDetailsBooking?.bookings;
        if (parsedBooking && parsedBooking.length > 0) {
            parsedBooking = JSON.parse(JSON.stringify(parsedBooking));
            parsedBooking.forEach((value) => {
                value.portOfLoadingName = exportJobDetails.portOfLoadingName;
                value.portOfDischargeName = exportJobDetails.portOfDischargeName;
                value.placeOfReceiptName = exportJobDetails.placeOfReceiptName;
                value.serviceAtOrigin = exportJobDetails.serviceAtOrigin;
                value.serviceAtDestination = exportJobDetails.serviceAtDestination;
                value.isTransferred = value.isTransferred ? 'Yes' : 'No';
            })
        }
        setExportJobDetailsBooking({ ...bookingInitialState, data: parsedBooking });
        setExportJobDetailsCargoState([
            { label: 'Quantity', value: formatValueIfNullOrUndefined(exportDetailsBooking?.totalQuantity) },
            { label: 'Package', value: formatValueIfNullOrUndefined(exportDetailsBooking?.totalPackages) },
            { label: 'Volume (m3)', value: formatValueIfNullOrUndefined(clearFormat(exportDetailsBooking?.totalVolume, 3)) },
            { label: 'Weight', value: formatValueIfNullOrUndefined(clearFormat(exportDetailsBooking?.totalWeight, 3)) },
			{ label: 'Special Cargo Indicator', value: exportDetailsBooking?.bookings[0]?.specialCargoIndicator ? exportDetailsBooking.bookings[0].specialCargoIndicator : '-' }
        ]);
        if (organisation !== null && organisation.length >= 4) {
            const newOrganisation = JSON.parse(JSON.stringify(organisation));
            if (exportDetailsBooking.bookings && exportDetailsBooking.bookings.length > 0) {
                newOrganisation[2].value = simplifyNull(exportDetailsBooking.bookings[0]?.officeCode, exportDetailsBooking.bookings[0]?.originSiteName)
                newOrganisation[3].value = simplifyNull(exportDetailsBooking.bookings[0]?.destinationSiteCode, exportDetailsBooking.bookings[0]?.destinationSiteName)
                setExportJobDetailsOrganizationState(newOrganisation);
            }
        }
    }, [exportDetailsBooking, organisation]);


    useEffect(() => {
        setExportJobDetailsClrState({ ...clrInitialState, data: exportDetailsClr });
    }, [exportDetailsClr]);

    useEffect(() => {
        let parsedCbl = exportDetailsCbl;
        if (parsedCbl && parsedCbl.length > 0) {
            parsedCbl = JSON.parse(JSON.stringify(parsedCbl));
            parsedCbl.forEach((value) => {
                value.portOfLoadingName = exportJobDetails.portOfLoadingName;
                value.portOfDischargeName = exportJobDetails.portOfDischargeName;
                value.placeOfReceiptName = exportJobDetails.placeOfReceiptName;
            })
        }
        setExportJobDetailsCblState({ ...cblInitialState, data: parsedCbl });
    }, [exportDetailsCbl]);

    useEffect(() => {
        const filteredEquipmentTransport = exportDetailsEts.filter(equipment => !equipment.isCancelled);
        let newEquipmentTransport: IExportDetailsEts[] = [];
        if (filteredEquipmentTransport && filteredEquipmentTransport.length) {
            newEquipmentTransport = filteredEquipmentTransport.map((data: any) => {
                if (data.anyIssoSent) {
                    data.anyIssoSent = data.anyIssoSent.toString()
                }
                return data;
            })
        }
        if (isExtraDocumentFeatureEnabled) {

            let exceptExtraDocsETS: IExportDetailsEts[] = [];
            if (newEquipmentTransport && newEquipmentTransport.length) {
                exceptExtraDocsETS = newEquipmentTransport.filter((val: any) => val.equipmentTransportShipmentDocumentNumber && !val.equipmentTransportShipmentDocumentNumber.startsWith('IED'));
            }
            setExportJobDetailsEtsState({ ...etsInitialState, data: exceptExtraDocsETS });

            let extraDocsETS: IExportDetailsEts[] = [];
            if (newEquipmentTransport && newEquipmentTransport.length) {
                extraDocsETS = newEquipmentTransport.filter((val: any) => val.equipmentTransportShipmentDocumentNumber && (val.equipmentTransportShipmentDocumentNumber.startsWith('IED')));
            }
            setExportJobDetailsExtraEtsState({ ...extraEtsInitialState, data: extraDocsETS });
        }
        else {
            setExportJobDetailsEtsState({ ...etsInitialState, data: newEquipmentTransport });
        }
    }, [exportDetailsEts]);

    useEffect(() => {
        let customerData = exportDetailsCustomerInvoice;
        customerData = customerData.map((data: any) => {
            const newData = formatData([data])
            return newData[0]
        })
        customerData = sortElementByKey(customerData, 'createdDate', true, 'date');
        setExportJobDetailsCustomerInvoiceState({ ...customerInvoiceInitialState, data: customerData });
    }, [exportDetailsCustomerInvoice]);


    const getExportJobDetailsApiData = (event: React.MouseEvent<HTMLDivElement>, object: any) => {
        if ((object.id === 'booking' || object.id === 'cargoDetails' || object.id === 'organisation') && object.isCollapse === false && exportDetailsBooking?.bookings?.length === 0) {
            props.fetchExportJobBookingDetails(Number(exportJobId));
        }
        if (object.id === 'clr' && object.isCollapse === false && exportDetailsClr.length === 0) {
            props.fetchExportJobClrDetails(Number(exportJobId));
        }
        if (object.id === 'cbl' && object.isCollapse === false && exportDetailsCbl.length === 0) {
            props.fetchExportJobCblDetails(Number(exportJobId));
        }
        if ((object.id === 'eqTransportShipments' || object.id === 'extraEqTransportShipments') && object.isCollapse === false && exportDetailsEts.length === 0) {
            props.fetchExportJobEtsDetails(Number(exportJobId));
        }
        if (object.id === 'customerInvoice' && object.isCollapse === false && exportDetailsCustomerInvoice.length === 0) {
            props.fetchExportJobInvoice(Number(exportJobId));
        }
    }

    return (
        <div className="padding-top-large padding-bottom-large">
            <AccordionNew text={'Organisation'} id="organisation" collapse={true} onClick={(e, object) => getExportJobDetailsApiData(e, object)}>
                {exportJobDetailsOrganizationState &&
                    <PropertyDisplay data={[...exportJobDetailsOrganizationState]} id="organisation" />
                }
            </AccordionNew>

            <AccordionNew text={'Locations'} id="locations" collapse={true} onClick={(e, object) => getExportJobDetailsApiData(e, object)}>
                <PropertyDisplay data={[...locations]} id="locations" />
            </AccordionNew>

            <AccordionNew text={'Cargo details'} id="cargoDetails" collapse={true} onClick={(e, object) => getExportJobDetailsApiData(e, object)}>
                {exportJobDetailsCargoState.length > 0 &&
                    <PropertyDisplay className="col-20" data={[...exportJobDetailsCargoState]} id="cargoDetails" />}
            </AccordionNew>

            <AccordionNew text={'Job Id details'} id="jobIdDetailsCollapse" collapse={true} onClick={(e, object) => getExportJobDetailsApiData(e, object)}>
                <PropertyDisplay data={[...jobIdDetails]} id="jobIdDetails" />
            </AccordionNew>

            <AccordionNew text={'Booking'} id="booking" collapse={true} onClick={(e, object) => getExportJobDetailsApiData(e, object)}>
                {exportJobDetailsBooking.data && <Table
                    {...exportJobDetailsBooking}
                    id="export-job-details-bookings"
                    hasTotal={true}
                    linkAction={(row: any) => props.link(String(`/job-costing/booking/${row!.id}`))} />}
            </AccordionNew>

            <AccordionNew text={'clr'} id="clr" collapse={true} onClick={(e, object) => getExportJobDetailsApiData(e, object)}>
                {exportJobDetailsClrState.data && <Table
                    {...exportJobDetailsClrState}
                    id="export-job-details-clr"
                    hasTotal={true}
                    linkAction={(row: any) => props.link(String(`/job-costing/cbls/${row!.id}`))} />}
            </AccordionNew>


            <AccordionNew text={'cbl'} id="cbl" collapse={true} onClick={(e, object) => getExportJobDetailsApiData(e, object)}>
                {exportJobDetailsCblState.data && <Table
                    {...exportJobDetailsCblState}
                    id="export-job-details-cbl"
                    hasTotal={true}
                    linkAction={(row: any) => props.link(String(`/job-costing/cbls/${row!.id}`))} />}
            </AccordionNew>

            <AccordionNew text={'equipment'} id="equipment" collapse={true}>
                <Table {...equipments} id="export-job-details-equipment"
                    hasTotal={true}
                    linkAction={(row: any) => props.link(String(`/job-costing/equipments/${row!.equipmentId}`))} />
            </AccordionNew>

            <AccordionNew text={'EQUIPMENT TRANSPORT SHIPMENTS'} id="eqTransportShipments" collapse={true} onClick={(e, object) => getExportJobDetailsApiData(e, object)}>
                {exportJobDetailsEtsState.data &&
                    <Table {...exportJobDetailsEtsState} hasTotal={true}
                        id="export-job-details-equipmentTransportShipments"
                        linkAction={(row: any) => props.link(String(`/job-costing/ets/${row!.id}`))} />}
            </AccordionNew>

            {isExtraDocumentFeatureEnabled &&
                <AccordionNew text={'Import Extra Document'} id="extraEqTransportShipments" collapse={true} onClick={(e, object) => getExportJobDetailsApiData(e, object)}>
                    {exportJobDetailsExtraEtsState.data &&
                        <Table {...exportJobDetailsExtraEtsState} hasTotal={true}
                            id="export-job-details-extraEquipmentTransportShipments"
                            linkAction={(row: any) => props.link(String(`/job-costing/ets/${row!.id}`))} />}
                </AccordionNew>
            }
            <AccordionNew text={'voyage'} id="voyages" collapse={true}>
                <Table {...voyages} id="export-job-details-voyages" />
            </AccordionNew>

            <AccordionNew text={'Customer Invoice'} id="customerInvoice" collapse={true} onClick={(e, object) => getExportJobDetailsApiData(e, object)}>
                <Table {...exportJobDetailsCustomerInvoiceState} id="export-job-details-customerInvoice"
                    linkAction={(row: any) => {
                        redirectToViewInvoice('origin', row!.internalBillingNumber);
                    }} />
            </AccordionNew>

        </div>
    );
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    exportDetailsBooking: state.exportJob.exportDetailsBooking,
    exportDetailsClr: state.exportJob.exportDetailsClr,
    exportDetailsCbl: state.exportJob.exportDetailsCbl,
    exportDetailsEts: state.exportJob.exportDetailsEts,
    exportDetailsCustomerInvoice: state.exportJob.exportDetailsCustomerInvoice,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IDispatch => ({
    fetchExportJobBookingDetails: (exportJobId: number) => dispatch(fetchExportJobBookingDetails(exportJobId)),
    fetchExportJobClrDetails: (exportJobId: number) => dispatch(fetchExportJobClrDetails(exportJobId)),
    fetchExportJobCblDetails: (exportJobId: number) => dispatch(fetchExportJobCblDetails(exportJobId)),
    fetchExportJobEtsDetails: (exportJobId: number) => dispatch(fetchExportJobEtsDetails(exportJobId)),
    fetchExportJobInvoice: (exportJobId: number) => dispatch(fetchExportJobCustomerInvoice(exportJobId)),

});

export default connect<IMapStateToProps, IDispatch, {}, IStore>(mapStateToProps, mapDispatchToProps)(ExportJobDetails);